import React, {useState, useEffect, useRef} from 'react';
import CustomTable from '../../../components/customTable/CustomTable';
import {getLanguage, t} from 'react-switch-lang';
import {
  getAllProcessesActiveAtSubProcesses, getAllProcessesAtSubProcesses,
} from '../../../services/Processes/processes';
import {
  createSubprocess,
  deleteSubprocess,
  updateSubprocess,
  deactivateSubprocess
} from '../../../services/Subprocesses/subprocesses';
import Toast from '../../../components/toast/Toast';
import Prompt from '../../../components/prompt/prompt';
import SearchBox from '../../../components/searchBox/SearchBox';
import Swal from 'sweetalert2';
import AddIcon from '../Metodologies/plus.png';

const Subprocesses = () => {
  const [query, setQuery] = useState();
  const [activeProcesses, setActiveProcesses] = useState([]);
  const [allProcesses, setAllProcesses] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [{ data: active }, { data: all }] = await Promise.all([
          getAllProcessesActiveAtSubProcesses(),
          getAllProcessesAtSubProcesses(),
        ]);

        setActiveProcesses(active);
        setAllProcesses(all);
      } catch (err) {}
    };

    fetchData();
  }, []);

  const formatedProcesses = activeProcesses?.map((d) => ({
    label: getLanguage() === 'eng' ? d?.nameEn : d?.name,
    value: d?.id,
  }));
  const allProcessesOptions = allProcesses?.map((d) => ({
    label: getLanguage() === 'eng' ? d?.nameEn : d?.name,
    value: d?.id,
    active: d?.active,
  }));

  const columns = [
    {
      dataIndex: 'name',
      title: t('common.name'),
      editable: true,
      placeholder: `${t('common.placeholder.name')}`,
      rules: [
        {required: true, message: t('message.fieldRequired')},
        {min: 3, message: t('message.min', {min: 3})},
        {max: 255, message: t('message.max', {max: 255})},
        {whitespace: true, message: t('message.fieldNotValid')},
      ],
    },
    {
      dataIndex: 'nameEn',
      title: t('common.nameEn'),
      editable: true,
      placeholder: `${t('common.placeholder.nameEn')}`,
      rules: [
        {required: true, message: t('message.fieldRequired')},
        {min: 3, message: t('message.min', {min: 3})},
        {max: 255, message: t('message.max', {max: 255})},
        {whitespace: true, message: t('message.fieldNotValid')},
      ],
    },
    {
      dataIndex: 'processId',
      nestedKey: getLanguage() === 'eng' ? 'nameEn' : 'name',
      title: t('subprocesses.Process'),
      editable: true,
      inputType: 'customSelect',
      options: formatedProcesses,
      render: (value) => {
        const process = allProcessesOptions?.find((d) => d?.value === value);
        return process?.label;
      },
      rules: [{required: true, message: t('message.fieldRequired')}],
    },
  ];

  const onUpdate = async (data, editingRecord, form) => {
    data.nameEn = data.nameEn.trim();
    data.name = data.name.trim();
    data.id = editingRecord.id;
    data.active = editingRecord.active
    try {
      const response = await updateSubprocess(data);
      if (response.status === 200) {
        Toast.fire({
          title: t('message.updateSuccess2', {
            entity: t('subprocesses.Subprocess'),
          }),
          icon: 'success',
        });
      }
      return response;
    } catch (err) {
      if (err.response.data.detail === 'name') {
        form.setFields([
          {
            name: 'name',
            errors: [t('subprocesses.subprocessExists')],
          },
        ]);
      } else if (err.response.data.detail === 'name_en') {
        form.setFields([
          {
            name: 'nameEn',
            errors: [t('subprocesses.subprocessExists')],
          },
        ]);
      }
    }
  };

  const onCreate = async (data, form) => {
    data.nameEn = data.nameEn.trim();
    data.name = data.name.trim();
    data.active = true
    try {
      const response = await createSubprocess(data);
      if (response.status === 201) {
        Toast.fire({
          title: t('message.addSuccess2', {
            entity: t('subprocesses.Subprocess'),
          }),
          icon: 'success',
        });
      }
      window.location.reload()
      return response;
    } catch (err) {
      if (err.response.data.detail === 'name') {
        form.setFields([
          {
            name: 'name',
            errors: [t('subprocesses.subprocessExists')],
          },
        ]);
      } else if (err.response.data.detail === 'name_en') {
        form.setFields([
          {
            name: 'nameEn',
            errors: [t('subprocesses.subprocessExists')],
          },
        ]);
      }
    }
  };

  const onDelete = async (record) => {
    let response;
    return new Promise((resolve, reject) => {
      Prompt.fire({
        title: t('subprocesses.Subprocess'),
        text: t('question.delete', {
          entity: getLanguage() === 'eng' ? record.nameEn : record.name,
        }),
        confirmButtonText: t('common.delete2').toUpperCase(),
        cancelButtonText: t('common.cancel').toUpperCase(),
        preConfirm: async () => {
          try {
            response = await deleteSubprocess(record.id);
            if (response.status === 204) {
              Toast.fire({
                title: t('message.deleteSuccess2', {
                  entity: t('subprocesses.Subprocess'),
                }),
                icon: 'success',
              });
              resolve(response);
            } else {
              reject(response);
            }
          } catch (err) {
            if (err?.response?.data?.code === 'subprocess_deactivation_blocked_by_open_risks') {
              Swal.fire({
                text: `${t("message.riskSubProcessDeactivationBlockedByOpenRisks")}`,
                icon: "error",
                confirmButtonText: "OK"
              });
            }else {
              Swal.fire({
                text: t('message.deleteFailed', {
                  entity: t('subprocesses.Subprocess'),
                }),
                icon: 'error',
              });
            }
          }
        },
      });
    });
    // return response;
  };
  const onDeactivate = async (record) => {
    let response;
    return new Promise((resolve, reject) => {
      Prompt.fire({
        title:
          record?.active
            ? `${t("buttons.deactivateBtn")} ${t('subprocesses.subprocess')}`
            :  `${t("buttons.activateBtn")} ${t('subprocesses.subprocess')}`,
        text:`${
          record?.active
            ? t("question.deactivate")
            : t("question.activate")
        } ${getLanguage() === "eng" ? record.nameEn : record.name}  ?`,
        confirmButtonText: record?.active
          ? t("buttons.deactivateBtn")
          : t("buttons.activateBtn"),
        cancelButtonText: t('common.cancel').toUpperCase(),
        preConfirm: async () => {
          try {
            response = await deactivateSubprocess(record?.id);
            if (response.status === 200) {
              Toast.fire({
                title: `${
                  record?.active
                    ? t("message.successDeactivate")
                    : t("message.successActivate")
                }`,
                icon: 'success',
              });
              setTimeout(() => {window.location.reload()}, 3000)
              resolve(response);
            } else {
              reject(response);
            }
          } catch (err) {
            if (err?.response?.data?.code === 'subprocess_deactivation_blocked_by_open_risks') {
              Swal.fire({
                text: `${t("message.riskSubProcessDeactivationBlockedByOpenRisks")}`,
                icon: "error",
                confirmButtonText: "OK"
              });
            }else {
              Swal.fire({
                text: `${t("message.errorApi")}`,
                icon: "error",
                confirmButtonText: "OK"
              });
            }
          }
        },
      });
    });
  };
  const addButton = useRef();
  return (
    <div className="subprocesses administration-template">
      <div className="w-100 d-flex justify-content-between mb-4">
        <div className="search">
          <SearchBox
            placeholder={t('subprocesses.searchSubprocesses')}
            setQuery={setQuery}
          />
        </div>
        <div className="button-add">
          <button className="btn btn-primary" ref={addButton}>
            <img src={AddIcon} alt="" />
            <p> {t('subprocesses.add')}</p>
          </button>
        </div>
      </div>
      {/* <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}> */}
          <CustomTable
            api="/subprocesses"
            query={query}
            sort={getLanguage() === "eng" ? "nameEn" : "name"}
            columns={columns}
            methods={{onUpdate, onDelete, onCreate, onDeactivate}}
            addButtonRef={addButton}
            actionsWidth={100}
            deactivateButton={true}
          />
        {/* </form>
      </FormProvider> */}
    </div>
  );
};

export default Subprocesses;
